import React, { FunctionComponent } from 'react';
import { MdMailOutline } from 'react-icons/md';
import { FiLock } from 'react-icons/fi';

// components
import BrandHeader from './PaywallElements/BrandHeader';
import Header from './PaywallElements/Header';
import Footer from './PaywallElements/Footer';
import {
  PasswordResetContainer,
  ForgotLabel,
  PaywallContainer,
  SectionContainer,
  StyledInput,
  FormContainer,
  ButtonHolder,
  Button,
  InputContainer,
  StyledIcon,
} from './StyledElements';

interface IconProps {
  color: string;
}

interface Props {
  branding?: any;
  hideLogo?: boolean;
}

const LoginScreen: FunctionComponent<Props> = ({
  branding: { paywall_secondary_color, paywall_primary_color, paywall_buttons_bg_color, paywall_brand_logo },
  hideLogo,
}: Props) => {
  return (
    <PaywallContainer>
      <BrandHeader backgroundColor={paywall_secondary_color} brandLogo={paywall_brand_logo} hideLogo={hideLogo!} />
      <Header borderColor={paywall_primary_color} />
      <SectionContainer>
        <FormContainer>
          <InputContainer>
            <StyledIcon as={MdMailOutline} color={paywall_primary_color} />
            <StyledInput borderColor={paywall_primary_color} type="text" placeholder="email" readOnly />
          </InputContainer>
          <InputContainer>
            <StyledIcon as={FiLock} color={paywall_primary_color} />
            <StyledInput borderColor={paywall_primary_color} type="text" placeholder="password" readOnly />
          </InputContainer>
          <PasswordResetContainer>
            <ForgotLabel>Forgot password?</ForgotLabel>
          </PasswordResetContainer>
          <ButtonHolder>
            <Button buttonBgColor={paywall_buttons_bg_color}>Log in</Button>
          </ButtonHolder>
        </FormContainer>
      </SectionContainer>
      <Footer backgroundColor={paywall_primary_color} />
    </PaywallContainer>
  );
};

export default LoginScreen;
